import { Injectable } from '@angular/core';
import { ExpectedDetection } from '../models/expectedDetection';



//TODO convert to injectable?
export class ConstantMan {
  public static ORIGIN = {
    LOCAL: 'http://localhost:4200',
    DEV: 'https://portal-test.veil.global',
    STAGE: 'https://portal-stage.veil.global',
    PROD: 'https://portal.veil.global',
    CUSTOM: 'https://' + 'portal.myadvocado.com'
  };

  public static CALENDLY = {
    LOCAL: 'https://calendly.com/cjt1105/experiment1et',
    DEV: 'https://calendly.com/cjt1105/experiment1et',
    STAGE: 'https://calendly.com/cjt1105/experiment1et',
    PROD: 'https://calendly.com/advocado-customer-success-meeting/advocado-customer-onboarding'
  };

  public static DATA_DICTIONARY_URL =
    'https://advocado-prod.s3.amazonaws.com/data-dictionary/Advocado+Data+Dictionary+-+LATEST.pdf';

  public static TWITTER_OAUTH_URL = 'https://api.twitter.com/oauth/authenticate?oauth_token='; //pass in token

  public static API = {
    BASE: {
      LOCAL: 'http://localhost:3000/',
      DEV: 'https://api-test.myadvocado.com/',
      STAGE: 'https://api-stage.myadvocado.com/',
      PROD: 'https://api.myadvocado.com/',
      CUSTOM: 'https://' + 'api.myadvocado.com' + '/'
    },
    EMBED: {
      LOCAL: 'http://localhost:3333',
      DEV: 'https://embed-test.myadvocado.com',
      STAGE: 'https://embed-stage.myadvocado.com',
      PROD: 'https://embed.myadvocado.com'
    },
    DNI_EMBED: {
      LOCAL: 'http://localhost:3333/embed/dni',
      DEV: 'https://detection-api-test.myadvocado.com/embed/dni',
      STAGE: 'https://detection-api-stage.myadvocado.com/embed/dni',
      PROD: 'https://detection-api.myadvocado.com/embed/dni'
    },
    DATA: {
      LOCAL: 'http://localhost:3030/',
      DEV: 'https://data-api-test.myadvocado.com/',
      STAGE: 'https://data-api-stage.myadvocado.com/',
      PROD: 'https://data-api.myadvocado.com/',
      CUSTOM: 'https://' + 'data-api.myadvocado.com' + '/'
    },
    RESEED: {
      LOCAL: 'http://localhost:3214/',
      DEV: 'https://reseed-test.myadvocado.com/',
      STAGE: 'https://reseed-stage.myadvocado.com/'
    },
    DET: {
      LOCAL: 'http://localhost:3333/',
      DEV: 'https://detection-api-test.myadvocado.com/',
      STAGE: 'https://detection-api-stage.myadvocado.com/',
      PROD: 'https://detection-api.myadvocado.com/',
      CUSTOM: 'https://' + 'detection-api.myadvocado.com' + '/'
    },
    CALL: {
      LOCAL: 'http://localhost:3456/',
      DEV: 'https://call-api-test.myadvocado.com/',
      STAGE: 'https://call-api-stage.myadvocado.com/',
      PROD: 'https://call-api.myadvocado.com/'
    },
    RESOURCE: {
      USER: 'users',
      LOGIN: 'login',
      LOGOUT: 'logout',
      SESSION: 'session',
      ROLE: 'roles',
      PERMISSION: 'permissions',
      TRIGGER: 'triggers',
      ADVERTISER: 'advertisers',
      BRAND: 'brands',
      ACTION: 'actions',
      DEPRECATED_CHANNEL: 'deprecatedchannels',
      AGENCY: 'agencys',
      FAILEDMUTATION: 'failedmutations',
      INVITE: 'invites',
      INTEGRATION: 'integrations',
      TRAAQRTAG: 'traaqrtags',
      CALLCONFIG: 'callconfigs',
      PHONENUMBER: 'phonenumbers',
      SITE: 'sites',
      DMA: 'dmas',
      CONSTANT: 'constants',
      REPORT: 'reports',
      GOOGLEACTION: 'googleactions',
      FACEBOOKACTION: 'facebookactions',
      AMAZONACTION: 'amazonactions',
      TWITTERACTIONS: 'twitteractions',
      SNAPCHATACTION: 'snapchatactions',
      INTEGRATIONINVITE: 'integrationinvites',
      SUBSCRIPTION: 'subscriptions',
      PAYMENTMETHOD: 'paymentMethods',
      BRANDCENTRAL: 'brandcentral',
      DATADESTINATION: 'datadestinations',
      SCHEDULEDREPORT: 'scheduledreports',
      CUSTOMTRIGGERPROVIDER: 'customtriggerproviders',
      STATION: 'stations',
      VIDVITACHANNEL: 'vidvitachannels',
      GOAL: 'goals',
      CUSTOMREPORT: 'customreports',
      BINGACTION: 'bingactions',
      TRADEDESKACTION: 'tradedeskactions',
      REDSHIFT: 'redshift',
      GOOGLEANALYTICS: 'googleanalytics',
      DBPEDIA: 'dbpedia',
      ALERT: 'alerts',
      PAYMENT: 'payments',
      POSTLOGCONFIGS: 'postlogconfigs',
      POSTLOGS: 'postlogs',
      POSTLOGPROVIDERS: 'postlogproviders',
      BIDDATA: 'biddata',
      KEYWORDS: 'keywords',
      GCLID: 'gclid',
      LEADSOURCES: 'leadsources',
      MASTERCHANNELS: 'masterchannels',
      MONITOREDCHANNELS: 'monitoredchannels',
      CHANNELCLUSTER: 'channelcluster',
      MARKETGROUPS: 'marketgroups',
      ATHENA: 'athena',
      BIGQUERY: 'BigQuery',
      AVS: 'avs',
      LOOKER: 'Looker',
      BUY_SCHEDULE_AUDITS: 'buyScheduleAudits',
      BUY_SCHEDULES: 'buySchedules',
      SCHEDULEDDETECTIONS: 'scheduledDetections',
      SINGLETON: 'singletons',
      STATIONCONTACTSBYUSER: 'stationContactsByUser',
      BUYSCHEDULECHANGEREQUESTS: 'buyScheduleChangeRequests',
      CHANNELMAPPINGS: 'channelmappings',
      CHANNELMAPPINGPROVIDERS: 'channelmappingproviders',
      SCHEDULE_ANALYTICS: 'scheduleanalytics',
      SCHEDULE_INGEST_CONFIG: 'scheduleingestconfigs',
      MATCHING_BACKFILL: 'matchingbackfills',
      CUSTOMERS: 'customers',
      FORMATS: 'formats',
      ENCODER_GROUPS: 'encodergroups',
      PROFILES: 'profiles',
      ENCODINGS: 'encodings',
      LOOKER_DASHBOARD_METADATA: 'LookerDashboardMetadata',
      CHANNELS: 'channels',
      MARKETS: 'markets'
      /* INSERT RESOURCE */
    },
    GET_METHODS: [
      //'DELETE',
      'GET',
      'HEAD',
      'JSONP',
      'OPTIONS'
    ]
  };

  public static STATUS_TYPE = {
    ACTIVE: 'active',
    INACTIVE: 'inactive'
  };

  //Default permissions ALL roles will always have.
  //Match these up with permissions.sql (node-api).
  public static DEFAULT_PERMISSIONS = [
    1, //Get all permissions
    2 //Get all roles
  ];

  public static WEATHER_CODES = {
    200: {
      label: 'Thunderstorm (2XX)',
      codes: []
    },
    300: {
      label: 'Drizzle (3XX)',
      codes: []
    },
    500: {
      label: 'Rain (5XX)',
      codes: []
    },
    600: {
      label: 'Snow (6XX)',
      codes: []
    },
    700: {
      label: 'Atmosphere (7XX)',
      codes: []
    },
    800: {
      label: 'Clouds (8XX)',
      codes: []
    }
  };

  public static TOKENS = {
    SEND_MESSAGE_KEY: 'h30djd393hfduhu834ghu0h094fuh34fha',
    BRAINTREE: {
      SANDBOX: '',
      PRODUCTION: ''
    }
  };

  public static WEATHER_QUERY_OPERATORS = ['=', '!=', '>', '>=', '<', '<=', 'increase', 'decrease'];

  public static WEATHER_QUERY = {
    FIELDS: [
      {
        name: 'temp',
        value: { name: 'Temp (F)', type: 'number', operators: ConstantMan.WEATHER_QUERY_OPERATORS, entity: 'temp' }
      },
      {
        name: 'feelsLike',
        value: {
          name: 'Feels Like Temp (F)',
          type: 'number',
          operators: ConstantMan.WEATHER_QUERY_OPERATORS,
          entity: 'feelsLike'
        }
      },
      {
        name: 'pressure',
        value: {
          name: 'Pressure (hPa)',
          type: 'number',
          operators: ConstantMan.WEATHER_QUERY_OPERATORS,
          entity: 'pressure'
        }
      },
      {
        name: 'humidity',
        value: {
          name: 'Humidity (%)',
          type: 'number',
          operators: ConstantMan.WEATHER_QUERY_OPERATORS,
          entity: 'humidity'
        }
      },
      {
        name: 'windSpeed',
        value: {
          name: 'Wind Speed (mph)',
          type: 'number',
          operators: ConstantMan.WEATHER_QUERY_OPERATORS,
          entity: 'windSpeed'
        }
      },
      {
        name: 'windGust',
        value: {
          name: 'Wind Gust (mph)',
          type: 'number',
          operators: ConstantMan.WEATHER_QUERY_OPERATORS,
          entity: 'windGust'
        }
      },
      {
        name: 'cloudCover',
        value: {
          name: 'Cloud Cover (%)',
          type: 'number',
          operators: ConstantMan.WEATHER_QUERY_OPERATORS,
          entity: 'cloudCover'
        }
      },
      {
        name: 'rain',
        value: { name: 'Rain (mm)', type: 'number', operators: ConstantMan.WEATHER_QUERY_OPERATORS, entity: 'rain' }
      },
      {
        name: 'snow',
        value: { name: 'Snow (mm)', type: 'number', operators: ConstantMan.WEATHER_QUERY_OPERATORS, entity: 'snow' }
      },
      {
        name: 'visibility',
        value: {
          name: 'Visibility (m)',
          type: 'number',
          operators: ConstantMan.WEATHER_QUERY_OPERATORS,
          entity: 'visibility'
        }
      },
      { name: 'codes', value: { name: 'Weather Codes', type: 'string', operators: ['=', '!='], entity: 'codes' } }
    ],
    REFERENCE_TYPE_OPTIONS: [
      { label: 'Average', value: 'average' },
      { label: 'High', value: 'high' },
      { label: 'Low', value: 'low' },
      { label: 'Exact Hour', value: 'exact' }
    ],
    CONDITION_TYPES: [
      {
        name: 'Clouds',
        iconClass: 'fas fa-cloud',
        bookendType: 'left',
        configTypes: ['visibility', 'codes'],
        codeLabels: ['Clouds (8XX)']
      },
      {
        name: 'Rain',
        iconClass: 'fas fa-cloud-showers-heavy',
        bookendType: 'none',
        configTypes: ['rain', 'codes'],
        codeLabels: ['Rain (5XX)', 'Drizzle (3XX)', 'Thunderstorm (2XX)']
      },
      {
        name: 'Snow',
        iconClass: 'fas fa-snowflake',
        bookendType: 'none',
        configTypes: ['snow', 'codes'],
        codeLabels: ['Snow (6XX)']
      },
      { name: 'Sun', iconClass: 'fas fa-sun', bookendType: 'none', configTypes: ['uvi'], codeLabels: [] },
      {
        name: 'Temperature',
        iconClass: 'fas fa-temperature-high',
        bookendType: 'none',
        configTypes: ['temp', 'feelsLike'],
        codeLabels: []
      },
      {
        name: 'Wind',
        iconClass: 'fas fa-wind',
        bookendType: 'none',
        configTypes: ['windSpeed', 'windGust'],
        codeLabels: []
      },
      {
        name: 'Atmosphere',
        iconClass: 'fas fa-tachometer-alt right-bookend',
        bookendType: 'right',
        configTypes: ['pressure', 'humidity', 'codes'],
        codeLabels: ['Atmosphere (7XX)']
      }
    ]
  };

  /**
   * Must match Settings -> Connect Settings in the Stripe Account
   */
  public static STRIPE_REDIRECTS = {
    LOCAL: 'http://localhost:4200/',
    TEST: 'https://portal-test.veil.global',
    PROD: 'https://portal.veil.global'
  };

  public static CHARTIST_COLORS = [
    '#85B05A',
    '#5182C2',
    '#472C83',
    '#507D43',
    '#CF774C',
    '#6D57BD',
    '#D170C4',
    '#92CE82',
    '#5BC7C1',
    '#851E77',
    '#B1CC97',
    '#50D973',
    '#C7A35B',
    '#2E73D1',
    '#C550D9',
    '#788060',
    '#CFC253',
    '#BD5C5C',
    '#4C6485',
    '#b1D155'
  ];

  public static UPLOAD_SCHEMES: UploadScheme[] = [
    {
      type: 'postlog',
      ready: 'postlog-upload-ready',
      start: 'postlog-upload-start',
      part: 'postlog-upload-part',
      finish: 'postlog-upload-finish',
      part_finish: 'postlog-upload-part-finish',
      abort: 'postlog-upload-abort'
    },
    {
      type: 'schedule',
      ready: 'schedule-upload-ready',
      start: 'schedule-upload-start',
      part: 'schedule-upload-part',
      finish: 'schedule-upload-finish',
      part_finish: 'schedule-upload-part-finish',
      abort: 'schedule-upload-abort'
    }
  ];

  // The left side is the avsProfileId, and the right is the looker group id
  public static LOOKER_PROFILE_GROUPS = {
    INTERNAL: {
      // Commercial 1
      1: '18',
      // Commercial 2
      6: '17',
      // Core Direct
      14: '22',
      // Datatech
      15: '23',
      // Donovan Data Systems
      8: '20',
      // Fox Sports 2
      300: '16',
      // Millenia 3
      16: '19',
      // Radio Commercial
      9: '21'
    },
    EXTERNAL: {
      // Commercial 1
      1: '20',
      // Commercial 2
      6: '21',
      // Core Direct
      14: '22',
      // Datatech
      15: '23',
      // Donovan Data Systems
      8: '24',
      // Fox Sports 2
      300: '25',
      // Millenia 3
      16: '26',
      // Radio Commercial
      9: '27'
    }
  }

  public static DAYS_OF_WEEK: DayOfWeek[] = [
    { name: 'Monday', abbreviation: 'M' },
    { name: 'Tuesday', abbreviation: 'Tu' },
    { name: 'Wednesday', abbreviation: 'W' },
    { name: 'Thursday', abbreviation: 'Th' },
    { name: 'Friday', abbreviation: 'F' },
    { name: 'Saturday', abbreviation: 'Sa' },
    { name: 'Sunday', abbreviation: 'Su' },
  ]



  public static DAYPARTS = [
    'All',
    'Overnight' ,
    'Early Morning' ,
    'Daytime' ,
    'Early Fringe'  ,
    'Early News' ,
    'Primetime' ,
    'Late News' ,
  ]
}

export interface UploadScheme {
  type: string;
  ready: string;
  start: string;
  part: string;
  finish: string;
  part_finish: string;
  abort: string;
}

export interface DayOfWeek {
  name: string,
  abbreviation: string
}

